import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import {
    Box, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    TableContainer, Paper, Chip, CircularProgress, Alert,
} from '@mui/material';
import { TokenContext } from '../Context/TokenContext';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const STATUS_LABELS = {
    pending: 'En attente', authorized: 'Autorisée', active: 'Active',
    ended: 'Terminée', expired: 'Expirée', revoked: 'Révoquée',
};
const STATUS_COLORS = {
    pending: 'default', authorized: 'info', active: 'success',
    ended: 'default', expired: 'warning', revoked: 'error',
};

// Historique des sessions de support — preuve d'accès demandée explicitement ("éviter tout
// souci préjudiciable") : lecture seule, aucune action d'édition/suppression ici ni côté API.
export default function SupportHistoryPage() {
    const { accessToken } = useContext(TokenContext);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!accessToken) return;
        axios.get(`${API_URL}/api/support/history`, { headers: { Authorization: `Bearer ${accessToken}` } })
            .then((r) => setHistory(r.data.history || []))
            .catch((err) => setError(err.response?.data?.error || err.message))
            .finally(() => setLoading(false));
    }, [accessToken]);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>Historique des sessions de support</Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                    <CircularProgress sx={{ color: 'primary.main' }} />
                </Box>
            ) : (
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Compte</TableCell>
                                <TableCell>Admin</TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell>Mode</TableCell>
                                <TableCell>Créée le</TableCell>
                                <TableCell>Terminée le</TableCell>
                                <TableCell>Enregistrement</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {history.map((s) => (
                                <TableRow key={s.id}>
                                    <TableCell>{s.account_key}</TableCell>
                                    <TableCell>{s.admin_public_id}</TableCell>
                                    <TableCell>
                                        <Chip size="small" label={STATUS_LABELS[s.status] || s.status} color={STATUS_COLORS[s.status] || 'default'} />
                                    </TableCell>
                                    <TableCell>{s.mode}</TableCell>
                                    <TableCell>{s.created_at ? new Date(s.created_at).toLocaleString('fr-FR') : '—'}</TableCell>
                                    <TableCell>{s.ended_at ? new Date(s.ended_at).toLocaleString('fr-FR') : '—'}</TableCell>
                                    <TableCell>{s.storage_path ? `${(s.size_bytes / 1024).toFixed(0)} Ko` : '—'}</TableCell>
                                </TableRow>
                            ))}
                            {history.length === 0 && (
                                <TableRow><TableCell colSpan={7} align="center">Aucune session de support enregistrée.</TableCell></TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
}
